<div class="dialog-top position-relative dialog-popup" [attr.data-popup-title]="data.title">
  @if (data.image) {
    <img class="popup-image" style="cursor: pointer" (click)="onImageClick()" [src]="data.image" [alt]="data.image_alt || data.title"/>
  }

  @if (data.title) {
    <h2 class="title px-l">{{data.title}}</h2>
  }

  @if (data.body) {
    <div class="popup-body px-l" [innerHTML]="data.body"></div>
  }

  @if (data.button) {
    <div mat-dialog-actions class="popup-actions px-l pb-l d-flex justify-content-end">
      <button mat-flat-button color="primary" (click)="onImageClick()">{{data.button}}</button>
    </div>
  }
</div>
